// =============================================================================
// ZONE EDITOR 3D - UTILITIES
// =============================================================================

// 1 unit = 1 meter
const SCALE = 1 / 1000

/**
 * Converte coordinate workspace (mm, Y-up) in coordinate Three.js (XZ plane, Y=elevation)
 */
export function mmToScene(x: number, y: number, elevation = 0): [number, number, number] {
  return [x * SCALE, elevation * SCALE, -y * SCALE]
}

export function mmToSceneScale(mm: number): number {
  return mm * SCALE
}

export function degreesToRadians(deg: number): number {
  return (deg * Math.PI) / 180
}

export function zoneColorToHex(led_color: [number, number, number]): number {
  return (led_color[0] << 16) | (led_color[1] << 8) | led_color[2]
}

// Fixed physical inclination of the espositore structure (degrees)
export const FIXED_SURFACE_TILT_DEG = 30
